const InformationIcon = ({ className = '' }: { className?: string }) => (
  <svg
    width='25'
    height='24'
    viewBox='0 0 25 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={`stroke-[#478FF2] ${className}`}
  >
    <path
      d='M12.499 8C12.361 8 12.249 8.112 12.25 8.25C12.25 8.388 12.362 8.5 12.5 8.5C12.638 8.5 12.75 8.388 12.75 8.25C12.75 8.112 12.638 8 12.499 8'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.5 21V21C7.529 21 3.5 16.971 3.5 12V12C3.5 7.029 7.529 3 12.5 3V3C17.471 3 21.5 7.029 21.5 12V12C21.5 16.971 17.471 21 12.5 21Z'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M12.5 12V17'
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)

export default InformationIcon
